import { useAllDemandsQuery } from "generated/graphql"
import { get } from "lodash-es"
import { useSelector } from "react-redux"
import { ApplicationState } from "store"
import { DEMAND_LIST_INITIAL_VARIABLES } from "./demand.queries.gql"

export const useDemandList = () => {
  const filter = useSelector<ApplicationState, any>(
    state => state.demands.filter
  )

  const liveStatus = filter?.isLive
  const isLive =
    liveStatus === "live" ? true : liveStatus === "not-live" ? false : null
  return useAllDemandsQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      ...DEMAND_LIST_INITIAL_VARIABLES,
      filter: {
        date_Gte: get(filter, "demandRange.0", null),
        date_Lte: get(filter, "demandRange.1", null),
        variety_Id: get(filter, "variety.id", null),
        depot_Id: get(filter, "depot.id", null),
        isLive: isLive,
      },
      search: get(filter, "search", ""),
      first: 12,
      skip: get(filter, "page", 0) * 12,
    },
  })
}
